/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../app/globals';
import { EnvVariables } from '../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../session';

@Injectable()
export class MainProcessProvider {
  constructor(
    // *** System
    private events: Events,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider) {
  }

  // *** Modifier le profil utilisateur
  public updateUserProfile(user: any) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        User: user
      };
      this.http.post(this.envVariables.process_updateUserProfile_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(data); },
        (error) => {
          let msg = JSON.parse(error._body).Message;
          console.log(msg);
          this.globals.showError(this.toastCtrl, msg);
          reject();
        }
      );
    });
  }

  // *** Modifier le profil utilisateur
  public changePassword(oldPassword: string, newPassword: string) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        OldPassword: oldPassword,
        NewPassword: newPassword
      };
      this.http.post(this.envVariables.process_changePassword_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(data); },
        (error) => {
          let msg = JSON.parse(error._body).Message;
          console.log(msg);
          this.globals.showError(this.toastCtrl, msg);
          reject();
        }
      );
    });
  }

  /// *** Définir le compte par défaut d'utilisateur
  public defineActiveAccount(account: any) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        CustomerID: account.CustomerID,
        AccountID: account.AccountID
      };
      this.http.post(this.envVariables.process_defineDefaultAccount_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(); },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject();
        }
      );
    });
  }

  // *** Ajouter/retirer un instrument de la liste des favoris
  public toggleFavorite(iSINCode: string) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        ISINCode: iSINCode
      };
      this.http.post(this.envVariables.process_toggleFavoriteInstrument_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => { resolve(); },
        (error) => {
          this.globals.showError(this.toastCtrl, error);
          reject();
        }
      );
    });
  }

  // *** Ajouter/retirer un instrument de la liste des favoris
  public readNotification(notificationID: number) {
    return new Promise((resolve, reject) => {
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let options = new RequestOptions({ headers: requestHeaders });
      let requestBody = {
        UserID: this.session.data.userID,
        NotificationID: notificationID
      };
      this.http.post(this.envVariables.process_readNotification_url, requestBody, options).map(res => res.json()).subscribe(
        (data) => {
          this.session.notificationCount = data;
          resolve();
        },
        (error) => {
          this.globals.showError(this.toastCtrl, error);
          reject();
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/processes/main.ts